import Vue from 'vue'
import App from './App.vue'
import Vuex from 'vuex'
import router from './router'
import store from './store'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import Amplify, { Logger } from 'aws-amplify'
import awsexports from './aws-exports'

import './registerServiceWorker'

Vue.config.productionTip = false

Vue.use(Vuex)
Vue.use(BootstrapVue)

library.add(fas)
Vue.component('font-awesome-icon', FontAwesomeIcon)
dom.watch()

Amplify.configure(awsexports)
Amplify.Logger.LOG_LEVEL = 'DEBUG'

const logger = new Logger('main')

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
